import React from 'react';

const LabelImagen = (props) => {
    return (
        <div className={props.col || 'col-12'}>
            <div className="mb-20">
                <label
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                    {props.label} {props.required && <span className="text-danger-600">*</span>}
                </label>
                <p>{props.value || ''} <span onClick={props.quitar} className="text-danger-600 cursor-pointer">Quitar</span></p>
            </div>
        </div>
    );
};

export default LabelImagen;
